import { createSlice } from "@reduxjs/toolkit";
import { snakeToCamel, sentenceToCamel } from "../../utils/transformString";

const initialState = {
  otherData: {
    bloodGlucose: {
      id: "1",
      classId: 4,
      title: "Blood Glucose",
      type: "other-data",
      data: [],
      favourite: false,
      selectedUnit: "milligramsPerDeciliter",
      unit: {
        milligramsPerDeciliter: {
          name: "milligramsPerDeciliter",
          symbol: "mg/dL",
          to: (value) => parseFloat(value?.toFixed(1)),
          from: (value) => parseFloat(value?.value),
          formConfig: [
            {
              symbol: "mg/dL",
              name: "value",
              type: "number",
              min: 30,
              max: 1000,
              step: "1",
            },
          ],
        },
        millimolesPerLitre: {
          name: "millimolesPerLitre",
          symbol: "mmol/L",
          to: (value) => parseFloat((value / 18)?.toFixed(1)),
          from: (value) => value.value * 18,
          formConfig: [
            {
              symbol: "mmol/L",
              name: "value",
              type: "number",
              min: 2,
              max: 56,
              step: "0.01",
            },
          ],
        },
      },
      chartConfig: {
        type: "bar",
        config: {
          label: "Blood Glocose",
        },
        multiValue: false,
      },
    },

    // sexualActivity: {
    //   id: "other2",
    // classId: 4,
    //   title: "Sexual Activity",
    //   type: "other-data",
    //   data: [],
    //   favourite: false,
    //   selectedUnit: "times",
    //   unit: {
    //     times: {
    //       name: "times",
    //       symbol: "times",
    //       to: (value) => parseFloat(value.toFixed(0)),
    //       from: (value) => parseFloat(value.value),
    //       formConfig: [
    //         {
    //           symbol: "times",
    //           name: "value",
    //           type: "number",
    //           min: 1,
    //           max: 10,
    //           step: "1",
    //         },
    //       ],
    //     },
    //   },
    //   chartConfig: {
    //     type: "bar",
    //     config: {
    //       label: "Sexual Activity",
    //     },
    //     multiValue: false,
    //   },
    // },

    bloodAlcoholContent: {
      id: "other3",
      classId: 4,
      title: "Blood Alchohol Content",
      type: "other-data",
      data: [],
      favourite: false,
      selectedUnit: "percentage",
      unit: {
        percentage: {
          name: "percentage",
          symbol: "%",
          to: (value) => parseFloat(value?.toFixed(1)),
          from: (value) => parseFloat(value?.value),
          formConfig: [
            {
              symbol: "%",
              name: "value",
              type: "number",
              min: 0,
              max: 1,
              step: "0.01",
            },
          ],
        },
      },
      chartConfig: {
        type: "bar",
        config: {
          label: "Blood Alchohol Content",
        },
        multiValue: false,
      },
    },
  },
  componentState: {
    dataState: null,
    vitalsDataState: null,
    firstRun: true,
    firstClick: false,
  },
};

const otherDataSlice = createSlice({
  name: "other data",
  initialState,
  reducers: {
    addData(state, action) {
      const { responseItem, titleId } = action.payload;
      const key = Object.keys(state.otherData).find(
        (key) => state.otherData[key].id === titleId
      );

      state.otherData[key].data.push({
        id: responseItem?.id,
        date: responseItem?.date,
        time: responseItem?.time,
        value: responseItem?.data.value,
      });
    },

    removeData(state, action) {
      const { id, titleId } = action.payload;
      const dataKey = Object.keys(state.heart).find(
        (key) => state.otherData[key].id === titleId
      );

      state.otherData[dataKey].data = state.otherData[dataKey].data.filter(
        (item) => item.id !== id
      );
    },

    changeUnit(state, action) {
      const { unit, titleId } = action.payload;
      const dataKey = Object.keys(state.otherData).find(
        (key) => state.otherData[key].id === titleId
      );

      state.otherData[dataKey].selectedUnit = unit;
    },

    toggleFavourite(state, action) {
      const { id } = action.payload;
      const dataKey = Object.keys(state.otherData).find(
        (key) => state.otherData[key].id === id
      );

      state.otherData[dataKey].favourite = !state.otherData[dataKey].favourite;
    },

    populateData(state, action) {
      const data = action.payload.data;
      const selectedUnit = action.payload.selectedUnit;
      const favourites = action.payload.favourites;
      const titles = action.payload.titles;

      for (let key in data) {
        const array = data[key].map((item) => {
          return {
            id: item.id,
            value: item.data.value,
            date: item.date,
            time: item.time,
          };
        });

        if (state.otherData[key]) {
          state.otherData[key].data = array;
        }
      }

      for (let key in selectedUnit) {
        const camelKey = snakeToCamel(key);

        if (state.otherData[camelKey]) {
          state.otherData[camelKey].selectedUnit = snakeToCamel(
            selectedUnit[key]
          );
        }
      }

      for (let key in favourites) {
        // const camelKey = snakeToCamel(key);
        if (state.otherData[key]) {
          state.otherData[key].favourite = favourites[key];
        }
      }
      titles.forEach((title) => {
        const camelName = sentenceToCamel(title.name);
        if (state.otherData[camelName]) {
          state.otherData[camelName].id = title.id;
          state.otherData[camelName].classId = title.class_title_id;
        }
      });
    },

    updateFirstRunState(state, action) {
      state.componentState.firstRun = action.payload;
    },
    updateDataState(state, action) {
      state.componentState.dataState = action.payload;
    },
    updateFirstClick(state, action) {
      state.componentState.firstClick = action.payload;
    },
    updateVitalsDataState(state, action) {
      state.componentState.vitalsDataState = action.payload;
    },
  },
});

export const otherDataActions = otherDataSlice.actions;

export default otherDataSlice.reducer;
